import React, { useState, useEffect } from "react";
import Button from "../Button/Button";
import "./CookieBanner.css";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setTimeout(() => {
        setIsVisible(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "all");
    setIsVisible(false);
    console.log("All cookies accepted");
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "essential");
    setIsVisible(false);
    console.log("Only essential cookies accepted");
  };

  const handleDetails = () => {
    alert(
      "Cookie details would be shown here. In a real implementation, this would open a modal with detailed options."
    );
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content container">
        <p className="cookie-message">
          We use cookies to personalise content and ads, to provide social media
          features and to analyse our traffic.
          <button className="cookie-details-link" onClick={handleDetails}>
            Details
          </button>
        </p>
        <div className="cookie-buttons">
          <Button
            type="primary"
            size="sm"
            text="Accept All"
            onClick={handleAccept}
          />
          <Button
            type="secondary"
            size="sm"
            text="Reject Non-Essential"
            onClick={handleReject}
          />
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
